module.exports = require("fbjs/lib/emptyFunction");


//////////////////
// WEBPACK FOOTER
// external "fbjs/lib/emptyFunction"
// module id = 38
// module chunks = 0